import type TasksAPI from '../apis/TasksAPI';
import type { CreateTaskPayload, Task, UpdateTaskPayload } from '../types/Tasks';
import BaseService from './BaseService';

function normalizeTask(raw: Task & { task_id?: string }): Task {
  return { ...raw, id: raw.task_id ?? raw.id };
}

export default class TasksService extends BaseService {
  private get api(): TasksAPI {
    return (this.host as unknown as { api: { tasks: TasksAPI } }).api.tasks;
  }

  async create(organizationId: string, payload: CreateTaskPayload): Promise<Task> {
    const raw = await this.api.create(organizationId, payload);
    return normalizeTask(raw);
  }

  async complete(organizationId: string, taskId: string): Promise<Task> {
    const raw = await this.api.complete(organizationId, taskId);
    return normalizeTask(raw);
  }

  async reopen(organizationId: string, taskId: string): Promise<Task> {
    const raw = await this.api.reopen(organizationId, taskId);
    return normalizeTask(raw);
  }

  async update(organizationId: string, taskId: string, payload: UpdateTaskPayload): Promise<Task> {
    const raw = await this.api.update(organizationId, taskId, payload);
    return normalizeTask(raw);
  }

  async list(organizationId: string, filter: 'open' | 'completed' = 'open'): Promise<Task[]> {
    const { tasks } = await this.api.list(organizationId, filter);
    return tasks.map(normalizeTask);
  }
}
